import React, { ButtonHTMLAttributes, FC } from 'react';

import { IPrimaryButtonStyles, StyledPrimaryButton } from './styles';

export type IButtonPrimaryProps = ButtonHTMLAttributes<HTMLButtonElement> & IPrimaryButtonStyles;

const ButtonPrimary: FC<IButtonPrimaryProps> = ({ children, ...props }) => (
  <StyledPrimaryButton {...props}>{children}</StyledPrimaryButton>
);

export default ButtonPrimary;
